import React from 'react'

type Props = {
    checked: boolean
    onChange: () => void
    disabled?: boolean
}

const ToggleSwitch: React.FC<Props> = ({ checked, onChange, disabled = false }) => {
    return (
        <label className={`relative inline-flex items-center ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
            <input
                type="checkbox"
                className="sr-only peer"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
            <div className={`relative w-11 h-6 rounded-full transition-colors ${
                checked 
                    ? 'bg-blue-600 dark:bg-blue-500' 
                    : 'bg-gray-300 dark:bg-gray-600'
            } ${!disabled && 'peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800'}`}>
                <div 
                    className="absolute top-0.5 left-0.5 bg-white rounded-full h-5 w-5 transition-transform duration-200 shadow-md"
                    style={{ transform: checked ? 'translateX(1.25rem)' : 'translateX(0)' }}
                ></div>
            </div>
        </label>
    )
}

export default ToggleSwitch
